import { gql } from "@apollo/client";

export const GET_INVOICE = gql`
	query GetInvoice($checkoutId: UUID!) {
		orders(condition: { checkoutId: $checkoutId }) {
			nodes {
				orderNumber
				createdAt
				shippingAddress {
					firstName
					lastName
					zipCode
					addressLine1
					addressLine2
					state {
						name
					}
					country {
						name
					}
				}
				billingAddress {
					firstName
					lastName
					zipCode
					addressLine1
					addressLine2
					state {
						name
					}
					country {
						name
					}
				}
				subtotalPrice
				shippingPrice
				totalTax
				totalDiscounts
				totalPrice
				orderItems {
					nodes {
						quantity
						variant {
							name
							price
							product {
								name
								imageSrc
							}
						}
					}
				}
			}
		}
	}
`;
